require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// d:/Vagrant/apache_vm/edu/wp-content/themes/portaledu-escolas/node_modules/core-js/modules/es7.symbol.observable.js
// module id = 278
// module chunks = 0